import React from 'react';
import { injectIntl } from 'react-intl';
import { Button, Grid, Typography } from '@mui/material';
import PenLine from 'lucide-react/dist/esm/icons/pen-line';

const ButtonStyle = {
  padding: 3,
  lineHeight: 1,
  minWidth: 71,
  textTransform: 'unset'
};

const IconWrapperStyle = {
  margin: '4px 0'
};

const WhiteboardButton = props => {
  const { intl, style, onClick } = props;

  return (
    <Button color="primary" onClick={onClick} style={{ ...ButtonStyle, ...style }}>
      <Grid container sx={{ flexDirection: 'column', alignItems: 'center' }}>
        <Grid style={IconWrapperStyle}>
          <PenLine size={24} color="var(--new-theme)" />
        </Grid>
        <Grid>
          <Typography align="center" color="textSecondary">
            {intl.formatMessage({ id: 'fin-py-handwriting-mode' })}
          </Typography>
        </Grid>
      </Grid>
    </Button>
  );
};

export default injectIntl(WhiteboardButton);
